import ReactDOM from 'react-dom/client';
import React from 'react';
import DemoPixelMap from './Demo';
import App from "../conductor/hoi/App";

export default function PixelMap() {
	const root = ReactDOM.createRoot(document.getElementById('root'));
	root.render(<DemoPixelMap/>);
}
